import { createIrisApiClient, basePaths } from 'API/clients/iris/irisapi'
import { filterParamSerializer } from 'API/utilities/filterParamSerializer'

const irisApiClient = createIrisApiClient(basePaths.iris)
const irisMeasurementClient = createIrisApiClient(basePaths.measurement)
const baseInspectionImagePath = 'inspection-image'
const baseInspectionImagesPath = 'inspection-images'

const annotationDetails = (imageUuid) =>
  irisApiClient.get(`/${baseInspectionImagePath}/${imageUuid}/annotation/details`)

const measurementDetails = (imageUuid) => irisMeasurementClient.get(`/image/${imageUuid}/`)

const updateReviewState = (reviewStateObj) => {
  const { imageUuid, reviewState } = reviewStateObj
  return irisApiClient.post(`/${baseInspectionImagePath}/${imageUuid}/update/review-state/`, {
    review_state: reviewState,
  })
}

const getInspectionImagesFiltered = (params?) => {
  return irisApiClient.get(`/${baseInspectionImagesPath}/`, {
    params,
    paramsSerializer: filterParamSerializer,
  })
}

export { annotationDetails, measurementDetails, updateReviewState, getInspectionImagesFiltered }
